export default __webpack_public_path__ + "static/media/jungle_1.ef241782.jpg";